import React, { useState, useEffect } from 'react';
import { fetchEquipos } from '../../../controller/dispositivosController'; // Importar función de API
import { Container, Table, Button } from 'react-bootstrap'; // Componentes Bootstrap
import { PencilSquare, Plus } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

function DispositivosView() {
  const [equipos, setEquipos] = useState([]); // Estado de equipos
  const [loading, setLoading] = useState(true); // Estado de carga
  const navigate = useNavigate(); // Hook para redirección

  // Llamar API al montar componente
  useEffect(() => {
    const getEquipos = async () => {
      try {
        const data = await fetchEquipos();
        setEquipos(data); // Actualizar estado
      } catch (error) {
        console.error('Error al obtener los equipos:', error);
      } finally {
        setLoading(false);
      }
    };

    getEquipos();
  }, []);

  if (loading) {
    return <h1>Cargando dispositivos...</h1>;
  }

  const handleEdit = (equipo) => {
    navigate(`/dispositivo/editDispositivo`, { state: { equipo } });
  };

  const handleCreate = () => {
    navigate(`/dispositivo/createDispositivo`);
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Dispositivos</h1>
        <Button variant="primary" onClick={handleCreate}>
          <Plus className="me-2" /> Crear Dispositivo
        </Button>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Modelo</th>
            <th>Dirección IP</th>
            <th>Puerto</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {equipos.map((equipo) => (
            <tr key={equipo.id}>
              <td>{equipo.name}</td>
              <td>{equipo.model || 'N/A'}</td>
              <td>{equipo.ip_address || 'N/A'}</td>
              <td>{equipo.port || 'N/A'}</td>
              <td>
                <Button variant="light" size="sm" onClick={() => handleEdit(equipo)}>
                  <PencilSquare color="blue" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default DispositivosView;
